import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./influencerProgramPage.gql"

export const useInfluencerProgramPage = (props) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const [customerType, setCustomerType] = useState("0")

  const {
    addInfluencerProgramMutation 
  } = operations

  const formApiRef = useRef(null)

  const [step, setStep] = useState(1)

  const [applicationType, setApplicationType] = useState({
    Instagram: true,
    Pinterest: true,
    Facebook: true,
    TikTok: true,
    Youtube: true,
    Blog: true,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [addInfluencerProgram, {
    data, error: addInfluencerProgramError 
  }] =
        useMutation(addInfluencerProgramMutation, {
          fetchPolicy: "no-cache",
        })

  const nextStep = useCallback(
    (no) => {
      document.body.scrollTop = 0 // Safari
      document.documentElement.scrollTop = 0 // Chrome, Firefox, IE and Opera
      setStep(no)
    },
    [setStep]
  )

  const selectType = useCallback(
    (val) => {
      const tempAppData = applicationType

      tempAppData[val] = !applicationType[val]
      setApplicationType(Object.assign({}, applicationType, {
        applicationType: tempAppData,
      }))
    },
    [applicationType, setApplicationType]
  )

  const handleSubmit = useCallback(
    async (formState) => {
      const values = formState.values

      setIsLoading(true)

      values["customerType"] = parseInt(values["customerType"], 10)

      Object.keys(values).map((item) => {
        values[item] =
                    values[item] === true
                      ? 1
                      : values[item] === false
                        ? 0
                        : values[item]
      })

      try {
        await addInfluencerProgram({
          variables: values,
        })
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setApplicationType({
          Instagram: true,
          Pinterest: true,
          Facebook: true,
          TikTok: true,
          Youtube: true,
          Blog: true,
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }

        setIsLoading(false)
      }
    },
    [addInfluencerProgram]
  )

  const errors = useMemo(
    () => new Map([["addInfluencerProgramError", addInfluencerProgramError]]),
    [addInfluencerProgramError]
  )

  return {
    formApiRef,
    step,
    nextStep,
    handleSubmit,
    applicationType,
    selectType,
    isLoading,
    errors,
    response: data && data.addInfluencerProgram,
    customerType,
    setCustomerType,
  }
}
